import React, {useState} from "react";
import PropTypes from 'prop-types';
import {Box, Button, Grid, makeStyles, Modal, Paper, Typography} from "@material-ui/core";
import CurrencyField from "../Fields/CurrencyField";
import TextField from "../Fields/TextField";
import useStyles from "../../styles/styles";
import ParseResponse from "../../utils/ParseResponse";
import {Alert} from "@material-ui/lab";
import setDate from "../../utils/setDate";
import LaunchIcon from "@material-ui/icons/Launch";

const useBoxStyles = makeStyles({
    root: {
        '& .MuiPaper-elevation1': {
            height: '400px',
            overflow: 'scroll'
        }
    },
});

const LeadPurchaseVendorCampaignDecisionInformation = ({decisions}) => {
    const classes = useStyles();
    const boxClasses = useBoxStyles();
    const [modalData, setModalData] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = info => {
        setModalData(info);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Typography variant="h4" component="h4" align="left" id={"lead-purchase-vendor-campaign-decisions"}>Lead Purchase Vendor Campaign Decisions</Typography>
            {decisions.map (decision => (
                <Paper className={classes.paper}>
                    <Grid container spacing={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Status" value={decision.status || ''}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <CurrencyField label="Billable" value={decision.billable}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <CurrencyField label="Payable" value={decision.payable}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Servicer" value={decision.servicer || ''}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Portfolio" value={decision.portfolio || ''}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Campaign" value={decision.campaignId || ''}/>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Status Code" value={decision.statusCode || ''}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Elapsed Time" value={decision.elapsedTime || ''}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Vendor Message" value={decision.vendorMessage || ''}/>
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <Button style={{ marginTop: "15px" }} variant="outlined" color="secondary" onClick={() => openModal({
                                    title: `Request: ${setDate(decision.requestTimestamp)}`,
                                    pre: decision.request
                                })}>
                                    Request
                                    <LaunchIcon/>
                                </Button>
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <Button style={{ marginTop: "15px" }} variant="outlined" color="secondary" onClick={() => openModal({
                                    title: `Response: ${setDate(decision.responseTimestamp)}`,
                                    pre: decision.response
                                })}>
                                    Response
                                    <LaunchIcon/>
                                </Button>
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <Button style={{ marginTop: "15px" }} variant="outlined" color="secondary" onClick={() => openModal({
                                    title: `Result - ${decision.statusCode}: ${setDate(decision.requestTimestamp)}`,
                                    pre: decision.result
                                })}>
                                    Result
                                    <LaunchIcon/>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            ))}

            <Modal
                open={isModalOpen}
                onClose={closeModal}
            >
                <Paper className={classes.modal}>
                    <h2>{modalData.title}</h2>

                    {modalData.pre ? (
                        <Box className={boxClasses.root}>
                            <ParseResponse data={modalData.pre}/>
                        </Box>
                    ) : (
                        <Alert severity="error">
                            Well, this in embarrassing&hellip; something went wrong.
                        </Alert>
                    )}
                </Paper>
            </Modal>
        </>
    )
};

LeadPurchaseVendorCampaignDecisionInformation.propTypes = {
    decision: PropTypes.shape({
        id: PropTypes.string,
        timestamp: PropTypes.string,
        requestId: PropTypes.string,
        servicer: PropTypes.string,
        portfolio: PropTypes.string,
        campaignId: PropTypes.string,
        campaignType: PropTypes.string,
        status: PropTypes.string,
        publisherTimeout: PropTypes.string,
        pricePoint: PropTypes.string,
        billable: PropTypes.string,
        payable: PropTypes.string,
        request: PropTypes.string,
        response: PropTypes.string,
        result: PropTypes.string,
        requestTimestamp: PropTypes.string,
        responseTimestamp: PropTypes.string,
        statusCode: PropTypes.string,
        type: PropTypes.string,
        elapsedTime: PropTypes.string,
        elapsedTimeSeconds: PropTypes.string,
        vendorMessage: PropTypes.string,
    }),
};

LeadPurchaseVendorCampaignDecisionInformation.defaultProps = {
    decision: {},
};

export default LeadPurchaseVendorCampaignDecisionInformation;
